import React, { useState } from 'react';
import {
  Book,
  House,
  Users,
  FileText,
  Receipt,
  ClipboardText,
  CalendarBlank,
  Package,
  UsersThree,
  Storefront,
  CreditCard,
  LinkSimple,
  Money,
  Files,
  ChartBar,
  UserGear,
  Target,
  CaretDown,
  CaretRight,
  CheckCircle,
  FunnelSimple,
  Briefcase,
  HardHat,
  Envelope,
  ChartLineUp,
  Binoculars,
  Trash,
  MagnifyingGlass,
  Star,
  Lightning,
  Gear,
  ShieldCheck,
  Gavel,
  MapPin,
  Clock,
  CalendarDots,
  SignIn,
  IdentificationBadge,
  Airplane
} from '@phosphor-icons/react';

const MANUAL_CATEGORIES = [
  {
    id: 'flow-diagram',
    title: 'Diagrama de Flujo del CRM',
    icon: ChartLineUp,
    color: 'text-emerald-600 bg-emerald-50',
    sections: [
      {
        id: 'lead-capture',
        title: 'Paso 1: Captura de Leads (3 Canales)',
        icon: Target,
        steps: [
          'El cliente ingresa a la pagina web iqeslowvoltage.com y puede contactarse por 3 canales simultaneos:',
          '  Canal 1 - Formulario de Cotizacion: El cliente llena el formulario en /quote con sus datos y servicios requeridos.',
          '  Canal 2 - Chatbot Inteligente: El chatbot guia al cliente con preguntas sobre su proyecto.',
          '  Canal 3 - Llamada con Agente Virtual Alex: El cliente llama y Alex (Retell AI) recopila la informacion.',
          'Los 3 canales envian automaticamente los datos al CRM via webhooks (POST /api/webhooks/quote-request, /chatbot, /retell).',
          'El sistema deduplica llamadas de Retell por call_id para evitar leads duplicados.',
        ]
      },
      {
        id: 'lead-processing',
        title: 'Paso 2: Procesamiento Automatico del Lead',
        icon: Lightning,
        steps: [
          'Al recibir los datos, el CRM automaticamente:',
          '  1. Crea el Lead con toda la informacion capturada (nombre, empresa, telefono, email, servicios, ubicacion, presupuesto).',
          '  2. Calcula el Lead Score (0-100) basado en: datos de contacto, fuente, servicios detallados, presupuesto, empresa.',
          '  3. Asigna automaticamente al tecnico/vendedor segun servicio y zona geografica.',
          '  4. Envia email de bienvenida al cliente con informacion de contacto de IQES.',
          '  5. Envia email de notificacion interna a info@iqeslowvoltage.com con los detalles del lead.',
          'El lead aparece en la lista de Leads con su score, fuente y asignacion. La pagina se actualiza automaticamente cada 30 segundos.',
        ]
      },
      {
        id: 'quote-generation',
        title: 'Paso 3: Generacion de Cotizacion',
        icon: FileText,
        steps: [
          'Opcion A - Auto-generacion: Desde el panel del lead, clic en "Generar Cotizacion Auto".',
          '  - El sistema extrae los servicios del lead y crea un borrador con BOM (Bill of Materials).',
          '  - Se asignan precios del catalogo automaticamente.',
          '  - Se convierte el lead en cliente automaticamente.',
          'Opcion B - Manual: Ir a Cotizaciones > Nueva Cotizacion, seleccionar cliente y agregar items del catalogo.',
          'El admin revisa la cotizacion generada, ajusta precios si es necesario.',
        ]
      },
      {
        id: 'quote-approval',
        title: 'Paso 4: Aprobacion Interna',
        icon: ShieldCheck,
        steps: [
          'El vendedor hace clic en "Solicitar Aprobacion" en la cotizacion.',
          'El admin recibe notificacion por email con los detalles.',
          'El admin abre la cotizacion y puede: Aprobar o Rechazar.',
          'Si rechaza: el vendedor recibe notificacion y puede hacer ajustes.',
          'Si aprueba: la cotizacion queda lista para enviar al cliente.',
        ]
      },
      {
        id: 'quote-send',
        title: 'Paso 5: Envio al Cliente',
        icon: Envelope,
        steps: [
          'Al aprobar, el admin hace clic en "Enviar al Cliente".',
          'El cliente recibe un email profesional con:',
          '  - PDF adjunto de la cotizacion.',
          '  - Link a pagina web interactiva para revisar la cotizacion.',
          'En la pagina web interactiva, el cliente tiene 2 opciones:',
          '  Opcion 1: "Aceptar y Firmar" - Firma digital con nombre completo.',
          '  Opcion 2: "Solicitar Modificaciones" - Escribe que cambios necesita.',
        ]
      },
      {
        id: 'flow-accept',
        title: 'Paso 6A: Cliente Acepta y Firma',
        icon: CheckCircle,
        steps: [
          'Al firmar digitalmente, el sistema automaticamente:',
          '  1. Genera Factura (Invoice) con el monto del anticipo (50%).',
          '  2. Crea Link de Pago en Stripe para el deposito.',
          '  3. Envia email al cliente con la factura y el link de pago.',
          '  4. Al recibir el pago exitoso:',
          '     - Confirma el pago al cliente y al equipo interno.',
          '     - Genera la Orden de Trabajo (Work Order) automaticamente.',
          '     - Programa la fecha de inicio en el Calendario del departamento de ingenieria.',
          '  5. El tecnico recibe notificacion de la nueva orden asignada.',
          'Este flujo es 100% automatico desde la firma hasta la programacion.',
        ]
      },
      {
        id: 'flow-modify',
        title: 'Paso 6B: Cliente Solicita Cambios',
        icon: Gear,
        steps: [
          'Si el cliente solicita modificaciones:',
          '  1. Se notifica al admin/vendedor por email con los cambios solicitados.',
          '  2. El vendedor edita la cotizacion segun las solicitudes.',
          '  3. Se regresa al Paso 4 (Aprobacion Interna).',
          '  4. Ciclo se repite hasta que el cliente acepte.',
        ]
      },
      {
        id: 'follow-up',
        title: 'Paso 7: Seguimiento de Leads',
        icon: Envelope,
        steps: [
          'Si un lead no responde, el admin puede enviar Follow-ups desde el panel del lead.',
          'El sistema tiene 3 plantillas automaticas segun el numero de seguimiento:',
          '  Follow-up #1: "Seguimiento - Su consulta sobre [servicio]" - Informativo y amigable.',
          '  Follow-up #2: "Recordatorio - Cotizacion pendiente" - Ofrece opciones de contacto.',
          '  Follow-up #3: "Ultima oportunidad - Oferta especial" - Descuento del 10%.',
          'Cada follow-up se registra en el lead con fecha y contador.',
        ]
      },
    ]
  },
  {
    id: 'getting-started',
    title: 'Primeros Pasos',
    icon: Star,
    color: 'text-amber-600 bg-amber-50',
    sections: [
      {
        id: 'login',
        title: 'Inicio de Sesion y Roles',
        icon: House,
        steps: [
          'Accede a la URL del CRM desde cualquier navegador (Chrome, Edge, Safari).',
          'Ingresa tu email y contrasena proporcionados por el administrador.',
          'Haz clic en "Iniciar Sesion". Si las credenciales son incorrectas, revisa mayusculas/minusculas.',
          'El sistema detecta tu rol automaticamente y muestra el menu correspondiente:',
          '  - Admin: Acceso total a todos los modulos, configuraciones y usuarios.',
          '  - Gerente (Manager): Igual que Admin pero sin gestion de usuarios.',
          '  - Vendedor (Sales): CRM, cotizaciones, pagos, prospectos B2B, reportes.',
          '  - Tecnico (Technician): Panel simplificado con ordenes de trabajo, calendario e inventario.',
          '  - Cliente: Portal del cliente para ver cotizaciones, facturas y pagos.',
        ]
      },
      {
        id: 'navigation',
        title: 'Navegacion del Sidebar',
        icon: FunnelSimple,
        steps: [
          'El menu lateral (sidebar) organiza los modulos en categorias desplegables.',
          'Categorias principales: CRM, Operaciones, Proyectos, Finanzas, Prospeccion B2B, Administracion.',
          'Haz clic en el nombre de una categoria para expandir/colapsar sus opciones.',
          'El sidebar se puede colapsar con el boton de menu (icono de 3 lineas) para mas espacio.',
          'En pantallas pequenas (movil), el sidebar se oculta automaticamente y se abre con el boton de menu.',
          'Las notificaciones aparecen con el icono de campana en la parte superior: alertas de stock bajo, pagos pendientes, etc.',
          'La barra de busqueda global permite buscar clientes, cotizaciones y facturas desde cualquier pagina.',
        ]
      },
      {
        id: 'dashboard',
        title: 'Dashboard Principal',
        icon: House,
        steps: [
          'El Dashboard muestra un resumen en tiempo real de todo el negocio.',
          'Tarjetas superiores: Total de Leads nuevos (ultimos 7 dias), Cotizaciones pendientes, Pagos del mes, Ordenes activas.',
          'Seccion de actividad reciente: muestra las ultimas cotizaciones, clientes y facturas creadas.',
          'Accesos rapidos: botones para crear nueva cotizacion, nuevo cliente o nueva orden de trabajo.',
          'Para tecnicos: El "Mi Panel" muestra solo sus ordenes asignadas y horas trabajadas.',
        ]
      },
    ]
  },
  {
    id: 'crm-module',
    title: 'CRM - Ventas',
    icon: FunnelSimple,
    color: 'text-blue-600 bg-blue-50',
    sections: [
      {
        id: 'pipeline',
        title: 'Pipeline de Ventas',
        icon: FunnelSimple,
        steps: [
          'El Pipeline muestra visualmente todos los leads en un flujo de 12 etapas.',
          'Las 12 etapas del pipeline son:',
          '  1. Contacto Inicial - Lead recien ingresado.',
          '  2. Necesidad Identificada - Se confirmo que tiene necesidad de servicios.',
          '  3. Cita Agendada - Se programo visita o llamada.',
          '  4. Site Survey - Visita tecnica al sitio.',
          '  5. Propuesta Enviada - Cotizacion formal enviada.',
          '  6. Negociacion - Ajustes de precio o alcance.',
          '  7. PO Recibida - Purchase Order del cliente.',
          '  8. Material Pedido - Se ordenaron los materiales.',
          '  9. Trabajo Programado - Instalacion agendada.',
          '  10. En Ejecucion - Trabajo en progreso.',
          '  11. Punch List - Detalles finales y correciones.',
          '  12. Cerrado Ganado - Proyecto completado y pagado.',
          'Arrastra los leads entre etapas para actualizar su estado.',
          'Cada tarjeta muestra: nombre, empresa, valor estimado y dias en la etapa.',
          'Filtra por vendedor asignado o por valor del deal.',
        ]
      },
      {
        id: 'leads',
        title: 'Leads (Prospectos Entrantes)',
        icon: Target,
        steps: [
          'Los Leads son prospectos que llegan por diferentes canales automaticos o manuales.',
          'CREAR LEAD MANUAL: Haz clic en "+ Nuevo Lead", completa nombre, email, telefono, mensaje y servicio de interes.',
          'CANALES AUTOMATICOS: Los leads llegan por 3 canales: Formulario Web (/quote), Chatbot y Agente Virtual Alex (Retell AI).',
          'LEAD SCORE: Cada lead recibe un puntaje automatico (0-100) basado en datos de contacto, servicios, presupuesto y fuente.',
          '  - Verde (70+): Alta probabilidad de conversion.',
          '  - Amarillo (40-69): Probabilidad media.',
          '  - Rojo (<40): Baja probabilidad.',
          'ASIGNACION AUTOMATICA: Los leads se asignan automaticamente al tecnico/vendedor segun el servicio y zona geografica.',
          'FILTROS: Filtra por estado (Nuevo, Contactado, Calificado, Convertido, Perdido) o por fuente (Cotizacion Web, Chatbot, Retell, etc.).',
          'DETALLE DEL LEAD: Haz clic en un lead para ver informacion completa, score, asignacion y acciones disponibles.',
          'GENERAR COTIZACION AUTO: Boton que crea automaticamente una cotizacion borrador con BOM desde los servicios del lead.',
          'ENVIAR FOLLOW-UP: Envia emails de seguimiento personalizados (3 plantillas segun el numero de seguimiento).',
          'CONVERTIR A CLIENTE: Usa el boton "Convertir a Cliente" para crear un registro completo de cliente.',
          'AUTO-REFRESH: La lista de leads se actualiza automaticamente cada 30 segundos.',
          'DEDUPLICACION RETELL: Si una llamada genera multiples eventos, el sistema crea 1 solo lead y actualiza la info.',
          'WEBHOOKS: URLs para configurar en el sitio web:',
          '  - Formulario: POST /api/webhooks/quote-request.',
          '  - Chatbot: POST /api/webhooks/chatbot.',
          '  - Retell AI: POST /api/webhooks/retell (configurado en Retell Dashboard).',
        ]
      },
      {
        id: 'clients',
        title: 'Clientes',
        icon: Users,
        steps: [
          'CREAR CLIENTE: Haz clic en "Nuevo Cliente" y completa: nombre, empresa, telefono, email, direccion.',
          'Selecciona el servicio de interes: Access Control, CCTV, Fibra Optica, Cableado, Networking, etc.',
          'Selecciona el idioma preferido (Espanol/Ingles) para cotizaciones y facturas bilingues.',
          'ESTADOS: Lead, Prospecto, Cliente activo, Inactivo.',
          'BUSCAR: Usa la barra de busqueda para encontrar por nombre, empresa o email.',
          'DETALLE DEL CLIENTE: Haz clic en un cliente para ver:',
          '  - Informacion de contacto completa.',
          '  - Historial de cotizaciones enviadas.',
          '  - Facturas y pagos asociados.',
          '  - Ordenes de trabajo realizadas.',
          '  - Boton "Crear Cotizacion" directamente desde la ficha.',
          'ELIMINAR CLIENTE: Disponible desde el detalle del cliente (solo Admin/Gerente).',
        ]
      },
      {
        id: 'quotes',
        title: 'Cotizaciones',
        icon: FileText,
        steps: [
          'CREAR COTIZACION: Haz clic en "Nueva Cotizacion" o creala desde el detalle de un cliente.',
          '  1. Selecciona el cliente de la lista.',
          '  2. Agrega la direccion del proyecto.',
          '  3. Agrega items: descripcion del servicio, cantidad, precio unitario.',
          '  4. El subtotal, impuesto y total se calculan automaticamente.',
          '  5. Configura el % de impuesto y los terminos de pago.',
          '  6. Agrega notas internas o para el cliente.',
          'FLUJO DE ESTADOS:',
          '  Borrador -> Aprobada -> Enviada -> Firmada -> Pagada.',
          'ACCIONES DISPONIBLES:',
          '  - "Aprobar": Cambia el estado a aprobada (requiere rol Admin/Gerente).',
          '  - "Enviar por Email": Envia la cotizacion con PDF adjunto al email del cliente.',
          '  - "Descargar PDF": Genera y descarga el documento PDF.',
          '  - "Crear Pago": Genera un enlace de pago Stripe (anticipo 50% o total).',
          '  - "Crear Factura": Genera factura automatica desde la cotizacion.',
          'ELIMINAR COTIZACION: Haz clic en el icono de basura en la lista. Solo Admin/Gerente pueden eliminar.',
          'FIRMA DEL CLIENTE: El cliente recibe un link unico para firmar digitalmente la cotizacion.',
          'SOLICITAR APROBACION: Envia la cotizacion al manager para revision.',
        ]
      },
    ]
  },
  {
    id: 'operations-module',
    title: 'Operaciones',
    icon: ClipboardText,
    color: 'text-orange-600 bg-orange-50',
    sections: [
      {
        id: 'work-orders',
        title: 'Ordenes de Trabajo',
        icon: ClipboardText,
        steps: [
          'CREAR ORDEN: Haz clic en "Nueva Orden" y completa:',
          '  1. Selecciona el cliente.',
          '  2. Titulo descriptivo del trabajo.',
          '  3. Direccion del sitio.',
          '  4. Fecha programada de inicio.',
          '  5. Prioridad: Baja, Normal, Alta, Urgente.',
          'ASIGNAR TECNICOS: Selecciona uno o mas tecnicos de la lista de usuarios activos.',
          'CHECKLIST (SOW): Agrega una lista de tareas que el tecnico debe completar.',
          '  - Cada tarea se puede marcar como completada.',
          '  - El progreso general se calcula automaticamente.',
          'MATERIALES: Agrega materiales del inventario. El stock se descuenta automaticamente.',
          'REGISTRO DE TIEMPO: Los tecnicos registran horas trabajadas por dia.',
          'ENVIAR AL TECNICO: El boton "Enviar al Tecnico" envia un email con PDF + documentos adjuntos.',
          'FLUJO DE ESTADOS: Programada -> En Progreso -> Completada.',
          'ORDENES AUTO-GENERADAS: Al confirmar un pago de anticipo, se crea automaticamente una orden de trabajo (marcada con badge morado).',
          'ELIMINAR: Disponible desde el detalle de la orden.',
        ]
      },
      {
        id: 'calendar',
        title: 'Calendario',
        icon: CalendarBlank,
        steps: [
          'El calendario muestra eventos de ordenes de trabajo y eventos personalizados.',
          'Navega entre meses con las flechas izquierda/derecha.',
          'Los dias con eventos se marcan con un punto de color.',
          'Haz clic en un dia para ver los eventos detallados de esa fecha.',
          'Los eventos se crean automaticamente al programar ordenes de trabajo.',
          'La lista lateral derecha muestra los proximos eventos cronologicamente.',
          'NOTA: La integracion con Google Calendar requiere configurar credenciales de Google Cloud.',
        ]
      },
      {
        id: 'technicians',
        title: 'Gestion de Tecnicos',
        icon: UsersThree,
        steps: [
          'Visualiza la lista de todos los tecnicos con su informacion de contacto.',
          'Cada tarjeta muestra: nombre, email, telefono, rol y estado (activo/inactivo).',
          'CREAR TECNICO: Los tecnicos se crean desde Administracion > Usuarios con rol "Technician".',
          'EDITAR: Haz clic en el icono de lapiz para editar nombre, email, telefono o rol.',
          'ELIMINAR: Haz clic en el icono de basura para eliminar un tecnico. Confirma la accion.',
          'ACTIVAR/DESACTIVAR: Usa el interruptor para activar o desactivar un tecnico sin eliminarlo.',
          'ORDENES ASIGNADAS: Desde el detalle puedes ver las ordenes de trabajo asignadas al tecnico.',
          'PORTAL DEL TECNICO: Los tecnicos acceden al CRM con su usuario y contrasena.',
          '  - Al iniciar sesion con rol "Technician", ven automaticamente "Mi Panel" con:',
          '  - Sus ordenes de trabajo asignadas.',
          '  - Calendario con sus citas.',
          '  - Inventario para consultar materiales disponibles.',
          '  - Registro de horas trabajadas.',
        ]
      },
    ]
  },
  {
    id: 'projects-module',
    title: 'Proyectos (Construccion)',
    icon: HardHat,
    color: 'text-indigo-600 bg-indigo-50',
    sections: [
      {
        id: 'projects',
        title: 'Gestion de Proyectos',
        icon: HardHat,
        steps: [
          'CREAR PROYECTO: Haz clic en "Nuevo Proyecto" y completa:',
          '  1. Nombre del proyecto.',
          '  2. Cliente asociado.',
          '  3. Direccion del sitio.',
          '  4. General Contractor (GC) - nombre y email.',
          '  5. Valor del contrato.',
          '  6. Fechas de inicio y fin estimadas.',
          'FASES DEL PROYECTO: Cada proyecto se divide en fases configurables.',
          '  - Agrega fases como: Cableado Estructurado, CCTV, Control de Acceso, etc.',
          '  - Cada fase tiene peso (%), fecha inicio/fin, estado y progreso.',
          '  - El progreso general del proyecto se calcula automaticamente desde las fases.',
          'DAILY LOGS (Bitacora Diaria): Registra notas de trabajo diario con fecha.',
          '  - Clima, numero de trabajadores, descripcion del trabajo realizado.',
          '  - Materiales utilizados y horas trabajadas.',
          'TIME ENTRIES (Registro de Tiempo): Registra horas por tecnico por dia.',
          'PURCHASE ORDERS (Ordenes de Compra): Crea POs para materiales del proyecto.',
          '  - Proveedor, items, cantidades, precios.',
          '  - Estados: Borrador, Enviada, Recibida.',
          'RFIs (Solicitudes de Informacion): Documenta preguntas tecnicas al GC o arquitecto.',
          'CHANGE ORDERS: Registra cambios al alcance original con impacto en costo y tiempo.',
          'REPORTE SEMANAL AL GC: Haz clic en "Enviar Reporte" para enviar un resumen al General Contractor.',
          '  - El reporte incluye: progreso por fase, horas trabajadas, fotos y notas.',
          '  - NOTA: Para enviar a emails externos, el dominio de Resend debe estar verificado en resend.com/domains.',
        ]
      },
    ]
  },
  {
    id: 'finance-module',
    title: 'Finanzas',
    icon: Receipt,
    color: 'text-emerald-600 bg-emerald-50',
    sections: [
      {
        id: 'invoices',
        title: 'Facturas',
        icon: Receipt,
        steps: [
          'CREAR FACTURA: Dos formas de crear facturas:',
          '  1. Manual: Haz clic en "Nueva Factura", selecciona cliente, agrega items.',
          '  2. Desde Cotizacion: En el detalle de una cotizacion aprobada, haz clic en "Crear Factura".',
          'CONFIGURAR: Define terminos de pago (Net 30, Net 15, etc.) y porcentaje de impuesto.',
          'ENVIAR: El boton "Enviar por Email" envia la factura con PDF adjunto al cliente.',
          'ESTADOS: Borrador -> Enviada -> Pagada / Vencida / Cancelada.',
          'TARJETAS RESUMEN: En la parte superior se muestra Total facturado, Por cobrar y Cobrado.',
          'DESCARGAR PDF: Genera y descarga la factura en formato PDF.',
          'ELIMINAR FACTURA: Haz clic en el icono de basura en la lista. Confirma la accion.',
        ]
      },
      {
        id: 'payments',
        title: 'Pagos',
        icon: CreditCard,
        steps: [
          'Los pagos se procesan via Stripe (actualmente en modo prueba).',
          'CREAR PAGO: Desde una cotizacion aprobada, haz clic en "Crear Pago".',
          '  - Anticipo (50%): Crea un pago parcial y genera automaticamente una Orden de Trabajo.',
          '  - Pago Completo (100%): Procesa el monto total.',
          'HISTORIAL: La lista muestra todos los pagos con estado:',
          '  - Iniciado: El cliente aun no ha completado el pago.',
          '  - Pagado: Pago confirmado por Stripe.',
          '  - Expirado: El link de pago expiro sin completarse.',
          'ACTUALIZAR ESTADO: Haz clic en el icono de flechas circulares para refrescar el estado desde Stripe.',
          'ELIMINAR PAGO: Haz clic en el icono de basura para eliminar un registro de pago (solo Admin/Gerente).',
          'TARJETA DE PRUEBA: Para pruebas usa 4242 4242 4242 4242, cualquier fecha futura y CVC.',
          'NOTA: Para pagos reales, el administrador debe cambiar a modo LIVE en la configuracion de Stripe.',
        ]
      },
      {
        id: 'payment-links',
        title: 'Links de Pago',
        icon: LinkSimple,
        steps: [
          'Crea links de pago independientes sin necesidad de cotizacion.',
          'CREAR: Haz clic en "Nuevo Link" y completa:',
          '  1. Nombre del cliente.',
          '  2. Email del cliente.',
          '  3. Descripcion del concepto (ej: "Instalacion CCTV - Anticipo").',
          '  4. Monto en dolares.',
          'El sistema genera automaticamente un link de Stripe Checkout.',
          'COMPARTIR: Copia el link o envialo por email directamente al cliente.',
          'ESTADOS: Activo (esperando pago), Pagado, Cancelado.',
          'Los pagos completados se registran automaticamente en el historial de pagos.',
        ]
      },
      {
        id: 'payroll',
        title: 'Payroll / Nomina',
        icon: Money,
        steps: [
          'Gestiona registros de tiempo y pagos de empleados/contratistas.',
          'AGREGAR ENTRADA: Selecciona empleado, fecha, horas trabajadas y tarifa por hora.',
          'El total por entrada se calcula automaticamente (horas x tarifa).',
          'ESTADOS: Borrador -> Aprobado -> Pagado.',
          'El resumen superior muestra total de horas y monto acumulado del periodo.',
        ]
      },
    ]
  },
  {
    id: 'b2b-module',
    title: 'Prospeccion B2B',
    icon: Briefcase,
    color: 'text-purple-600 bg-purple-50',
    sections: [
      {
        id: 'prospects',
        title: 'Prospectos B2B',
        icon: Briefcase,
        steps: [
          'El modulo B2B gestiona la prospeccion activa hacia empresas (General Contractors, corporaciones).',
          'CREAR PROSPECTO: Haz clic en "Nuevo Prospecto" y completa:',
          '  - Empresa, contacto, cargo, email, telefono, sitio web.',
          '  - Industria, servicios necesarios, zona geografica.',
          '  - Temperatura: Frio, Tibio, Caliente.',
          'PIPELINE B2B: Cada prospecto avanza por etapas configurables.',
          'ASISTENTE IA "ALEX": En el detalle del prospecto, la pestana "Chat" te conecta con Alex.',
          '  - Alex genera emails personalizados basados en el perfil del prospecto.',
          '  - Analiza la empresa y sugiere estrategias de acercamiento.',
          '  - Genera propuestas de valor adaptadas a cada industria.',
          '  - Puedes pedirle que redacte emails de seguimiento, cold emails o propuestas.',
          'ACCIONES RAPIDAS: Enviar email, programar llamada, actualizar estado, agregar notas.',
        ]
      },
      {
        id: 'campaigns',
        title: 'Campanas B2B',
        icon: Envelope,
        steps: [
          'Organiza prospectos en campanas de outreach.',
          'CREAR CAMPANA: Nombre, descripcion, fecha inicio/fin, tipo de campana.',
          'AGREGAR PROSPECTOS: Selecciona prospectos existentes para incluir en la campana.',
          'SEGUIMIENTO: Monitorea respuestas, tasas de apertura y conversiones.',
          'Cada campana muestra metricas de rendimiento.',
        ]
      },
      {
        id: 'b2b-reports',
        title: 'Reportes B2B',
        icon: ChartLineUp,
        steps: [
          'Panel de metricas de la prospeccion B2B.',
          'METRICAS CLAVE: Total de prospectos, tasa de respuesta, conversion a clientes.',
          'PESTANA MARKET INTEL KPIs: Muestra estadisticas de la inteligencia de mercado.',
          '  - Empresas analizadas, score promedio de compatibilidad.',
          '  - Licitaciones monitoreadas, score promedio de bids.',
          '  - Prospectos creados desde Market Intel.',
          'Filtros por periodo, industria y estado.',
        ]
      },
      {
        id: 'market-intel',
        title: 'Inteligencia de Mercado',
        icon: Binoculars,
        steps: [
          'Modulo avanzado de analisis de mercado impulsado por IA. Tiene 6 pestanas:',
          '',
          'PESTANA 1 - ANALIZAR:',
          '  - Ingresa la URL del sitio web de un General Contractor.',
          '  - La IA analiza automaticamente: servicios, proyectos, ubicacion, tamano.',
          '  - Genera un Score de Compatibilidad (0-100) con IQES.',
          '  - Muestra checklist de cumplimiento y recomendaciones.',
          '  - Si la URL ya fue analizada antes, muestra datos existentes (sin duplicar).',
          '  - Automaticamente busca 8-12 empresas similares.',
          '',
          'PESTANA 2 - DESCUBRIMIENTO:',
          '  - Busqueda automatica de General Contractors por estado.',
          '  - Selecciona estados (Florida, Texas, etc.) y tipos de trabajo.',
          '  - La IA encuentra GCs que subcontratan servicios de baja tension.',
          '  - Cada resultado incluye datos de contacto y score de compatibilidad.',
          '  - Boton "Crear Prospecto" para agregarlo directamente al pipeline B2B.',
          '',
          'PESTANA 3 - LICITACIONES:',
          '  - Busca oportunidades de licitaciones activas en 12+ plataformas.',
          '  - Plataformas: SAM.gov, DemandStar, BidNet, FloridaBids, etc.',
          '  - FILTRO DE ESTADO: Filtra por Activas, Expiradas o Todas.',
          '  - Cada licitacion muestra: titulo, agencia, tipo (ITB/RFP/RFQ), presupuesto estimado.',
          '  - Badge de estado: Verde (Activa), Rojo (Expirada), Gris (Desconocido).',
          '  - Fecha limite (deadline) con formato visual claro.',
          '  - Score de compatibilidad y estrategia de participacion sugerida.',
          '  - Boton "Crear Prospecto" para cada oportunidad.',
          '  - ALERTAS POR EMAIL: Configura alertas automaticas diarias/semanales de nuevas licitaciones.',
          '',
          'PESTANA 4 - EMPRESAS (Busqueda por Sector):',
          '  - Busca empresas con +20 empleados en sectores especificos para cold emailing.',
          '  - SECTORES DISPONIBLES: Empresas de Inversiones, Hoteles, Centros Educativos, Universidades, Almacenes de Cadena, Cadenas de Comida, Restaurantes, Hospitales, Centros Comerciales, Oficinas Corporativas, Data Centers, Bancos.',
          '  - Tambien puedes agregar sectores personalizados escribiendolos manualmente.',
          '  - UBICACIONES: Selecciona estados prioritarios (Florida, Texas, New York, California, etc.).',
          '  - MINIMO DE EMPLEADOS: Configurable de 10 a 500+.',
          '  - RESULTADOS: Cada empresa incluye nombre, ubicacion, num. empleados, email de contacto, razon por la que necesitaria servicios de low voltage, servicios potenciales y angulo sugerido para cold email.',
          '  - Boton "Crear Prospecto" para agregar directamente al pipeline.',
          '  - Las busquedas se guardan en historial para referencia futura.',
          '',
          'PESTANA 5 - HISTORIAL:',
          '  - Lista todas las empresas analizadas con sus scores.',
          '  - Puedes re-seleccionar un analisis anterior para ver sus detalles.',
          '',
          'PESTANA 6 - REQUISITOS:',
          '  - Muestra el checklist de cumplimiento necesario para licitar/subcontratar.',
          '  - Requisitos como licencias, seguros, certificaciones, registros estatales.',
        ]
      },
    ]
  },
  {
    id: 'admin-module',
    title: 'Administracion',
    icon: UserGear,
    color: 'text-slate-600 bg-slate-100',
    sections: [
      {
        id: 'users',
        title: 'Gestion de Usuarios',
        icon: UserGear,
        steps: [
          'Solo Admin puede crear, editar y desactivar usuarios.',
          'CREAR USUARIO: Haz clic en "Nuevo Usuario" y completa nombre, email, contrasena y rol.',
          'ROLES DISPONIBLES:',
          '  - Admin: Control total del CRM.',
          '  - Manager (Gerente): Gestion operativa sin control de usuarios.',
          '  - Sales (Vendedor): Ventas, cotizaciones, pagos y prospeccion.',
          '  - Technician (Tecnico): Ordenes de trabajo, calendario e inventario.',
          '  - Client (Cliente): Portal del cliente.',
          'EDITAR: Cambia nombre, email, contrasena o rol de cualquier usuario.',
          'DESACTIVAR: Los usuarios desactivados no pueden iniciar sesion pero se conserva su historial.',
          'ELIMINAR: Elimina permanentemente un usuario (no se puede deshacer).',
          'PORTAL DEL CLIENTE: Para dar acceso al portal del cliente:',
          '  1. Crea un usuario con rol "Client".',
          '  2. Al crear, selecciona el cliente asociado (debe existir primero en Clientes).',
          '  3. El cliente accede a /portal con su email y contrasena.',
          '  4. Ve: sus cotizaciones, facturas y puede aprobar/firmar documentos.',
        ]
      },
      {
        id: 'inventory',
        title: 'Inventario',
        icon: Package,
        steps: [
          'AGREGAR PRODUCTO: Haz clic en "Nuevo Producto" y completa:',
          '  - Nombre, SKU, categoria, unidad de medida.',
          '  - Cantidad en stock, precio de costo, precio de venta.',
          '  - Nivel minimo de stock (para alertas automaticas).',
          'CATEGORIAS: Cables, Camaras, Controles de Acceso, Redes, Herramientas, Accesorios.',
          'STOCK: Se descuenta automaticamente al asignar materiales a ordenes de trabajo.',
          'HISTORIAL: Consulta movimientos de cada producto (entradas, salidas, ajustes manuales).',
          'ALERTAS: Cuando un producto baja del nivel minimo, aparece una notificacion automatica.',
          'AJUSTE MANUAL: Puedes ajustar stock manualmente (ej: por inventario fisico o perdidas).',
        ]
      },
      {
        id: 'catalog',
        title: 'Catalogo de Precios',
        icon: Storefront,
        steps: [
          'El catalogo contiene todos los servicios que ofrece la empresa con precios de referencia.',
          'CATEGORIAS: Access Control, CCTV, Fibra Optica, Cableado Estructurado, Networking, Audio/Video.',
          'Cada servicio muestra: nombre, descripcion, precio minimo, maximo y promedio.',
          'EDITAR PRECIOS: Haz clic en un servicio para actualizar sus precios.',
          'API PUBLICA: El catalogo esta disponible via API para sincronizar con tu sitio web.',
          '  - URL: /api/catalog/public/services (acceso sin autenticacion).',
          '  - Permite que tu sitio web muestre precios actualizados automaticamente.',
        ]
      },
      {
        id: 'documents',
        title: 'Documentos',
        icon: Files,
        steps: [
          'Almacen central de documentos del negocio.',
          'SUBIR: Arrastra archivos o haz clic para seleccionar: PDFs, imagenes, planos, contratos.',
          'VINCULAR: Los documentos se pueden vincular a clientes, cotizaciones u ordenes.',
          'ANALISIS IA: La herramienta de IA puede extraer informacion clave de planos y blueprints.',
          'Los documentos se adjuntan automaticamente al enviar ordenes de trabajo por email al tecnico.',
        ]
      },
      {
        id: 'reports',
        title: 'Reportes y Analitica',
        icon: ChartBar,
        steps: [
          'Panel de reportes con multiples vistas:',
          'REPORTE DE VENTAS: Total de cotizaciones, pagos, tasa de conversion, ingresos mensuales.',
          'REPORTE DE ORDENES: Ordenes por estado, por tecnico, productividad del equipo.',
          'RENTABILIDAD POR PROYECTO: Ingresos vs costos, margen de ganancia por proyecto.',
          'RESUMEN DE INVENTARIO: Valor total del inventario, productos con stock bajo.',
          'RENDIMIENTO DE TECNICOS: Ordenes completadas, horas trabajadas, eficiencia por tecnico.',
          'Todos los reportes se pueden filtrar por rango de fechas.',
        ]
      },
    ]
  },
  {
    id: 'client-portal-module',
    title: 'Portal del Cliente',
    icon: SignIn,
    color: 'text-cyan-600 bg-cyan-50',
    sections: [
      {
        id: 'client-portal-overview',
        title: 'Acceso y Login del Cliente',
        icon: SignIn,
        steps: [
          'El Portal del Cliente permite a tus clientes acceder a un panel dedicado con su informacion.',
          'URL DE ACCESO: El cliente ingresa directamente a /client-login (pagina independiente del CRM interno).',
          'CREAR ACCESO PARA UN CLIENTE:',
          '  1. Ve a Administracion > Usuarios.',
          '  2. Haz clic en "Nuevo Usuario" y selecciona el rol "Client".',
          '  3. Ingresa el email y contrasena del cliente.',
          '  4. Selecciona el cliente asociado de la lista (debe existir previamente en el modulo Clientes).',
          '  5. Alternativamente, usa la funcion "Invitar Cliente" desde la gestion de usuarios.',
          'El cliente recibe sus credenciales por email o directamente del admin.',
          'SEGURIDAD: El portal del cliente esta completamente separado del CRM interno.',
          '  - Los clientes NO pueden ver informacion de otros clientes.',
          '  - Solo tienen acceso a SUS cotizaciones, facturas, ordenes y citas.',
        ]
      },
      {
        id: 'client-portal-dashboard',
        title: 'Dashboard del Cliente',
        icon: House,
        steps: [
          'Al iniciar sesion, el cliente ve su Dashboard con 4 tarjetas resumen:',
          '  1. Total Cotizaciones: Cantidad de cotizaciones recibidas.',
          '  2. Facturas Pendientes: Facturas por pagar.',
          '  3. Ordenes Activas: Trabajos en progreso.',
          '  4. Citas Programadas: Proximas citas agendadas.',
          'El Dashboard se actualiza en tiempo real al recargar la pagina.',
        ]
      },
      {
        id: 'client-portal-tabs',
        title: 'Modulos del Portal (4 Pestanas)',
        icon: IdentificationBadge,
        steps: [
          'El portal tiene 4 pestanas principales:',
          '',
          'PESTANA 1 - COTIZACIONES:',
          '  - Lista todas las cotizaciones enviadas al cliente.',
          '  - Muestra: numero, fecha, total y estado (Borrador, Aprobada, Enviada, Firmada, Pagada).',
          '  - El cliente puede ver los detalles completos de cada cotizacion.',
          '  - Acceso al link de firma digital si la cotizacion fue enviada.',
          '',
          'PESTANA 2 - FACTURAS:',
          '  - Lista todas las facturas asociadas al cliente.',
          '  - Muestra: numero de factura, fecha, monto, estado de pago.',
          '  - Si hay un link de pago activo, el cliente puede pagar directamente desde aqui.',
          '',
          'PESTANA 3 - ORDENES DE TRABAJO:',
          '  - Lista las ordenes de trabajo del cliente.',
          '  - Muestra: numero de orden, titulo, estado (Programada, En Progreso, Completada).',
          '  - El cliente puede ver el progreso de sus instalaciones.',
          '',
          'PESTANA 4 - CITAS:',
          '  - Lista las citas/bookings programados con el equipo de IQES.',
          '  - Muestra: fecha, hora, servicio solicitado, estado (Pendiente, Confirmada, Completada).',
          '  - Las citas se crean desde el Widget de Booking (ver seccion Booking).',
        ]
      },
    ]
  },
  {
    id: 'hrms-module',
    title: 'HRMS - Recursos Humanos',
    icon: Clock,
    color: 'text-rose-600 bg-rose-50',
    sections: [
      {
        id: 'hrms-clock',
        title: 'Reloj de Entrada/Salida (Clock In/Out)',
        icon: Clock,
        steps: [
          'El modulo HRMS permite registrar las horas de trabajo de todo el equipo.',
          'CLOCK IN: Los empleados hacen clic en "Entrada" al iniciar su jornada laboral.',
          '  - Se registra la hora exacta y la fecha.',
          '  - El boton cambia a "Salida" mientras el turno esta activo.',
          'CLOCK OUT: Al finalizar la jornada, hacen clic en "Salida".',
          '  - Se calcula automaticamente las horas trabajadas.',
          '  - Se registra como una entrada de tiempo completa.',
          'HISTORIAL: El admin puede ver el historial de registros por usuario y por fecha.',
          'NOTAS: Los empleados pueden agregar notas a cada registro (ej: "Trabajo remoto", "Horas extra").',
          'RESUMEN: El panel muestra el total de horas trabajadas por dia, semana y mes.',
        ]
      },
      {
        id: 'hrms-pto',
        title: 'PTO - Dias Libres (Vacaciones)',
        icon: Airplane,
        steps: [
          'El sistema de PTO gestiona solicitudes de dias libres con balance anual.',
          '',
          'BALANCE ANUAL:',
          '  - Cada empleado tiene 15 dias de PTO por ano (configurable por el admin).',
          '  - El balance se calcula automaticamente: 15 - (dias aprobados del ano) = dias disponibles.',
          '  - El admin puede ajustar el balance individual desde la configuracion.',
          '',
          'SOLICITAR DIAS LIBRES:',
          '  1. El empleado va a HRMS > Dias Libres.',
          '  2. Selecciona fecha de inicio y fecha de fin.',
          '  3. Escribe una nota explicativa (ej: "Vacaciones familiares").',
          '  4. El sistema calcula automaticamente cuantos dias se solicitan.',
          '  5. Si no hay balance suficiente, el sistema rechaza la solicitud.',
          '  6. Haz clic en "Enviar Solicitud".',
          '',
          'FLUJO DE APROBACION:',
          '  1. La solicitud queda en estado "Pendiente".',
          '  2. El Admin/Manager recibe notificacion.',
          '  3. Desde la lista de solicitudes, puede "Aprobar" o "Rechazar".',
          '  4. Al aprobar: se descuentan los dias del balance del empleado.',
          '  5. Al rechazar: los dias no se descuentan.',
          '',
          'NOTIFICACIONES POR EMAIL:',
          '  - Al aprobar o rechazar, el empleado recibe un email automatico con el resultado.',
          '  - El email incluye: fechas solicitadas, dias, razon y nuevo balance disponible.',
          '',
          'VISTA DE HISTORIAL:',
          '  - Cada empleado ve su historial de solicitudes con estado (Pendiente, Aprobada, Rechazada).',
          '  - El admin ve TODAS las solicitudes de todos los empleados.',
        ]
      },
    ]
  },
  {
    id: 'gps-module',
    title: 'GPS Tracking',
    icon: MapPin,
    color: 'text-teal-600 bg-teal-50',
    sections: [
      {
        id: 'gps-tracking',
        title: 'Rastreo de Tecnicos en Tiempo Real',
        icon: MapPin,
        steps: [
          'El modulo de GPS permite rastrear la ubicacion de los tecnicos en campo.',
          '',
          'MAPA EN TIEMPO REAL:',
          '  - Ve a la seccion "GPS" en el menu lateral.',
          '  - El mapa muestra los marcadores de cada tecnico activo.',
          '  - Cada marcador incluye: nombre del tecnico, ultima ubicacion reportada y hora.',
          '',
          'COMO FUNCIONA:',
          '  - Los tecnicos con la sesion activa reportan su ubicacion automaticamente.',
          '  - La ubicacion se actualiza cada vez que el tecnico tiene el CRM abierto en su movil.',
          '  - El admin puede ver a todo el equipo de campo en un solo mapa.',
          '',
          'BENEFICIOS:',
          '  - Saber que tecnico esta mas cerca de una nueva orden urgente.',
          '  - Verificar que los tecnicos estan en el sitio del proyecto.',
          '  - Optimizar rutas y asignaciones de trabajo.',
          '',
          'PRIVACIDAD:',
          '  - Solo el Admin y Managers pueden ver las ubicaciones.',
          '  - Los tecnicos solo ven su propia ubicacion.',
          '  - La ubicacion se registra solo durante horario laboral.',
        ]
      },
    ]
  },
  {
    id: 'booking-module',
    title: 'Booking / Agenda de Citas',
    icon: CalendarDots,
    color: 'text-pink-600 bg-pink-50',
    sections: [
      {
        id: 'booking-widget',
        title: 'Widget de Reservas',
        icon: CalendarDots,
        steps: [
          'El sistema de Booking permite a los clientes agendar citas directamente.',
          '',
          'COMO FUNCIONA:',
          '  1. El admin comparte el link del widget de booking con los clientes.',
          '  2. El cliente abre el formulario y ve los horarios disponibles.',
          '  3. Selecciona: servicio requerido, fecha y hora preferida.',
          '  4. Completa sus datos: nombre, email, telefono y descripcion del proyecto.',
          '  5. Envia la solicitud de cita.',
          '',
          'GESTION DE CITAS:',
          '  - Las citas nuevas aparecen con estado "Pendiente" en el panel de Booking.',
          '  - El admin puede: Confirmar, Completar o Cancelar cada cita.',
          '  - Las citas confirmadas aparecen automaticamente en el Calendario del CRM.',
          '  - Las citas tambien se muestran en el Portal del Cliente (pestana Citas).',
          '',
          'ESTADOS DE CITAS:',
          '  - Pendiente: Recien creada, esperando confirmacion.',
          '  - Confirmada: Aprobada por el equipo, fecha y hora fijadas.',
          '  - Completada: La cita se realizo exitosamente.',
          '  - Cancelada: La cita fue cancelada.',
          '',
          'INTEGRACION:',
          '  - El widget se puede integrar en la pagina web de IQES como un link externo.',
          '  - Las citas generan automaticamente notificaciones al equipo.',
          '  - URL del widget: /booking (acceso publico, no requiere login).',
        ]
      },
    ]
  },
  {
    id: 'tips-module',
    title: 'Tips y Recomendaciones',
    icon: Lightning,
    color: 'text-amber-600 bg-amber-50',
    sections: [
      {
        id: 'tips',
        title: 'Mejores Practicas',
        icon: CheckCircle,
        steps: [
          'FLUJO IDEAL DE VENTA:',
          '  1. Lead entra por chatbot/llamada -> Se califica en Pipeline.',
          '  2. Se convierte a Cliente -> Se crea Cotizacion.',
          '  3. Se aprueba y envia la cotizacion -> Cliente firma.',
          '  4. Se crea Pago -> Cliente paga por Stripe.',
          '  5. Se genera Orden de Trabajo automaticamente.',
          '  6. Tecnico ejecuta y completa la orden.',
          '  7. Se crea Factura final -> Se marca como pagada.',
          '',
          'FLUJO IDEAL B2B:',
          '  1. Usa Inteligencia de Mercado > Analizar para evaluar un GC.',
          '  2. Si el score es alto, usa "Crear Prospecto" para agregarlo.',
          '  3. En el detalle del prospecto, usa Alex AI para generar cold emails.',
          '  4. Organiza prospectos en Campanas para seguimiento.',
          '  5. Monitorea licitaciones activas para nuevas oportunidades.',
          '  6. Usa la pestana Empresas para encontrar clientes en otros sectores.',
          '',
          'TIPS GENERALES:',
          '  - Mantiene actualizado el inventario para evitar sorpresas en obra.',
          '  - Registra horas diariamente, no al final de la semana.',
          '  - Usa el catalogo para mantener precios consistentes en cotizaciones.',
          '  - Configura alertas de email para licitaciones y no pierdas deadlines.',
          '  - Revisa el Dashboard diariamente para ver metricas clave.',
          '  - Usa el Portal del Cliente para que tus clientes consulten sus cotizaciones y facturas sin llamarte.',
          '  - Configura las solicitudes de PTO desde el principio del ano para planificar mejor.',
          '  - Comparte el link de Booking en tu pagina web para captar mas citas automaticamente.',
        ]
      },
      {
        id: 'troubleshooting',
        title: 'Solucion de Problemas Comunes',
        icon: Gear,
        steps: [
          '"No puedo iniciar sesion": Verifica email y contrasena (distingue mayusculas). Contacta al Admin para resetear.',
          '"Error al enviar email/reporte": El dominio de Resend debe estar verificado. Ve a resend.com/domains para configurar.',
          '"El pago no se refleja": Haz clic en el boton de actualizar (flechas circulares) en la lista de pagos para sincronizar con Stripe.',
          '"No veo ciertos modulos": Tu rol determina que modulos puedes ver. Solicita al Admin cambiar tu rol si necesitas mas acceso.',
          '"El stock no se desconto": Verifica que el producto este correctamente vinculado a la orden de trabajo.',
          '"La cotizacion no se envia por email": Verifica que el email del cliente sea correcto y que el servicio de email (Resend) este configurado.',
          '"No puedo eliminar un registro": Solo Admin y Gerente pueden eliminar cotizaciones, facturas, pagos y usuarios.',
          '"Mi cliente no puede acceder al portal": Verifica que el usuario fue creado con rol "Client" y que el email coincide. El acceso es por /client-login.',
          '"Las solicitudes de PTO no se envian": Verifica que el empleado tiene balance disponible (15 dias por defecto). El admin puede ajustar el balance.',
          '"El mapa GPS no muestra tecnicos": Los tecnicos deben tener sesion activa y permisos de ubicacion habilitados en su navegador.',
          '"Las citas de Booking no aparecen": Verifica que el widget de booking es accesible en /booking. Las citas nuevas quedan en estado Pendiente.',
        ]
      },
    ]
  },
];

function SectionItem({ section, isOpen, onToggle }) {
  const Icon = section.icon;
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden bg-white" data-testid={`manual-section-${section.id}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center gap-3 p-4 hover:bg-slate-50 transition-colors text-left"
        data-testid={`manual-toggle-${section.id}`}
      >
        <div className="p-2 bg-blue-50 rounded-lg text-blue-600 shrink-0">
          <Icon size={20} />
        </div>
        <span className="flex-1 font-semibold text-slate-900 text-sm sm:text-base">{section.title}</span>
        {isOpen ? <CaretDown size={18} className="text-slate-400" /> : <CaretRight size={18} className="text-slate-400" />}
      </button>
      {isOpen && (
        <div className="px-4 pb-4 space-y-2 border-t border-slate-100 pt-3">
          {section.steps.map((step, i) => (
            step === '' ? <div key={i} className="h-2" /> :
            <div key={i} className="flex items-start gap-3">
              {step.startsWith('  ') ? (
                <>
                  <span className="w-4 shrink-0" />
                  <p className="text-sm text-slate-500">{step.trim()}</p>
                </>
              ) : (
                <>
                  <CheckCircle size={16} className="text-green-500 shrink-0 mt-0.5" weight="fill" />
                  <p className="text-sm text-slate-600">{step}</p>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ManualPage() {
  const [openSections, setOpenSections] = useState(new Set(['login']));
  const [activeCategory, setActiveCategory] = useState(null);

  const toggleSection = (id) => {
    setOpenSections(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const allSectionIds = MANUAL_CATEGORIES.flatMap(c => c.sections.map(s => s.id));
  const expandAll = () => setOpenSections(new Set(allSectionIds));
  const collapseAll = () => setOpenSections(new Set());

  const expandCategory = (cat) => {
    const ids = cat.sections.map(s => s.id);
    setOpenSections(prev => {
      const next = new Set(prev);
      ids.forEach(id => next.add(id));
      return next;
    });
    setActiveCategory(cat.id);
  };

  const filteredCategories = activeCategory
    ? MANUAL_CATEGORIES.filter(c => c.id === activeCategory)
    : MANUAL_CATEGORIES;

  return (
    <div className="space-y-6 animate-fadeIn max-w-4xl mx-auto" data-testid="manual-page">
      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-900 flex items-center gap-2">
            <Book size={28} className="text-blue-600" />
            Manual de Usuario
          </h1>
          <p className="text-sm text-slate-500 mt-1">Guia completa paso a paso de todos los modulos del CRM</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={expandAll}
            className="px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors"
            data-testid="expand-all-btn"
          >
            Expandir todo
          </button>
          <button
            onClick={collapseAll}
            className="px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors"
            data-testid="collapse-all-btn"
          >
            Colapsar todo
          </button>
        </div>
      </div>

      {/* Quick nav */}
      <div className="bg-white border border-slate-200 rounded-xl p-4" data-testid="manual-quick-nav">
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-3">Navegacion Rapida</p>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => { setActiveCategory(null); collapseAll(); }}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors ${!activeCategory ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:border-blue-300 hover:text-blue-600'}`}
            data-testid="manual-nav-all"
          >
            Todos
          </button>
          {MANUAL_CATEGORIES.map(cat => {
            const CatIcon = cat.icon;
            return (
              <button
                key={cat.id}
                onClick={() => expandCategory(cat)}
                className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors flex items-center gap-1.5 ${activeCategory === cat.id ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:border-blue-300 hover:text-blue-600'}`}
                data-testid={`manual-nav-${cat.id}`}
              >
                <CatIcon size={14} />
                {cat.title}
              </button>
            );
          })}
        </div>
      </div>

      {/* Info card */}
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <p className="text-sm text-blue-800">
          <strong>IQES CRM</strong> - Sistema de gestion integral para Low Voltage Solutions.
          Este manual cubre {allSectionIds.length} modulos organizados en {MANUAL_CATEGORIES.length} categorias. Haz clic en cada seccion para ver las instrucciones detalladas.
        </p>
      </div>

      {/* Categories and Sections */}
      {filteredCategories.map(category => {
        const CatIcon = category.icon;
        return (
          <div key={category.id} className="space-y-3" data-testid={`manual-category-${category.id}`}>
            <div className="flex items-center gap-2 pt-2">
              <div className={`p-1.5 rounded-lg ${category.color}`}>
                <CatIcon size={18} />
              </div>
              <h2 className="text-base font-bold text-slate-800">{category.title}</h2>
              <div className="flex-1 h-px bg-slate-200 ml-2" />
            </div>
            {category.sections.map(section => (
              <SectionItem
                key={section.id}
                section={section}
                isOpen={openSections.has(section.id)}
                onToggle={() => toggleSection(section.id)}
              />
            ))}
          </div>
        );
      })}

      {/* Downloads */}
      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
        <h3 className="text-sm font-bold text-slate-700 mb-3">Documentos Descargables</h3>
        <div className="flex flex-wrap gap-3">
          <a href="/manual-crm.html" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-blue-700 transition">
            Manual Completo (HTML)
          </a>
          <a href="/flujo-crm.html" target="_blank" rel="noopener noreferrer" className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-indigo-700 transition">
            Flujos de Trabajo CRM + B2B
          </a>
          <a href="/service-portfolio.html" target="_blank" rel="noopener noreferrer" className="bg-slate-700 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-slate-800 transition">
            Service Portfolio IQES
          </a>
          <a href="/IQES-Flujo-Tecnico-Funcional.docx" download className="bg-emerald-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-emerald-700 transition" data-testid="download-flow-tecnico">
            Flujo Técnico-Funcional (Word)
          </a>
          <a href="/IQES-Flujo-Ejecutivo.docx" download className="bg-pink-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-pink-700 transition" data-testid="download-flow-ejecutivo">
            Flujo Ejecutivo (Word)
          </a>
          <a href="/manual-crm-completo.html" target="_blank" rel="noopener noreferrer" className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-indigo-700 transition" data-testid="download-manual-completo">
            Manual Completo (HTML)
          </a>
          <a href="/guia-portales-licitaciones.html" target="_blank" rel="noopener noreferrer" className="bg-amber-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-amber-700 transition" data-testid="download-guia-portales">
            Guía Portales Licitación
          </a>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-slate-100 rounded-xl p-4 text-center">
        <p className="text-sm text-slate-500">
          IQES LLC | 255 S Orange Avenue, Suite 104 #1905, Orlando, FL 32801 | Tel: 786-436-7307
        </p>
        <p className="text-xs text-slate-400 mt-1">Manual v3.0 - CRM Version 2026 | {allSectionIds.length} modulos documentados</p>
      </div>
    </div>
  );
}
